<div class="row">
  <div class="col-xl-12 justify-content-center">
    <h2>Information</h2>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-xl-4">
    <div class="card card-shadow card-body rounded-border my-4 py-3">
      <div class="d-flex justify-content-start">
        <h5><span class="badge badge-pill badge-primary bg-gradient">General Info</span></h5>
      </div>
      <div style="height: 200px; overflow: hidden;">
        <dl class="row mb-0" style="font-size: 12px;">
          <dd class="col-5 text-primary">Username: </dd>
          <dd class="col-7">
            {{currentUser.username}}
          </dd>

          <dd class="col-5 text-primary">Created At: </dd>
          <dd class="col-7">
            {{currentUser.createdAt | date : 'medium'}}
          </dd>
        </dl>
      </div>
    </div>
  </div>

  <div class="col-xl-4">
    <div class="card card-shadow card-body rounded-border my-4 py-3">
      <div class="d-flex justify-content-start">
        <h5><span class="badge badge-pill badge-primary bg-gradient">Password Change </span></h5>
      </div>
      <div class="" style="height: 200px;">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <dl class="row mb-0" style="font-size: 12px;">
            <dt class="col-5 text-primary">Old Password: </dt>
            <dd class="col-7">
              <input type="password" class="form-control form-control-sm" formControlName="oldPassword">
              <div class="text-danger small" *ngIf="showError">
                <div *ngIf="f.oldPassword.errors?.required">
                  Old Password is required.
                </div>
              </div>
            </dd>
            <dd class="col-12 my-2"></dd>
            <dt class="col-5 text-primary">New Password: </dt>
            <dd class="col-7">
              <input type="password" class="form-control form-control-sm" formControlName="newPassword">
              <div class="text-danger small" *ngIf="showError">
                <div *ngIf="f.newPassword.errors?.required">
                  New Password is required.
                </div>
                <div *ngIf="f.newPassword.errors?.minlength">
                  New Password characters must not less than 5.
                </div>
              </div>
            </dd>
          </dl>
          <div class="text-center mt-4">
            <button class="btn btn-outline-primary" *ngIf="!processing">Change Password</button>
            <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
